import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[accesskey-func]',
    standalone: false
})
export class AccessKeyFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}